
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Agreement from "../../components/Agreement/Agreement";
import MainButtons from "../../butttons/mainButtons/MainButtons";

export const AgreementPage = () => {

  return (
    <div >
      <Header/>
      <Agreement/>
      <MainButtons/>
      <Footer/>
    </div>

  );
};

